module.exports = __webpack_public_path__ + "static/media/dev-ops.f36279b7.svg";